<template>
    <!-- 上传附件 -->
    <div class="wk-input-date wk-input-box" :style="styleCpt">
        <span v-if="labelOver" class="input-left-label">{{labelOver}}</span>
        <div class="posi-relative">
            <input-base :id="id" @click="setDateLang(false)" v-model="inputVal" classCpt="dateInput" 
                :placeholder="placeholderOver" :initVal="value" readonly ref="inputRef"/>
            <!-- 上传按钮 -->
            <div class="posi-absolute" :class="{'lang-date':isLangDate}"> 
                <!-- <img class="posi-absolute" src="../../assets/img/register-icon-10.png"> -->
                <span @click="setDateLang(true)">长期</span>     
            </div>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
        props: ['label', 'id','dtName','value','placeholder','styleCpt'],
        mounted(){
            let that = this;
            //初始化时间控件
            laydate.render({
                elem:'#' + that.id, //指定元素
                showBottom: false,
                //trigger: 'click', //触发方式，默认 focus
                min: that.$tools.getDateNew(0).split('-').join(''),
                done:function(value){ //选定日期或单击按钮后
                    that.inputVal = value;
                    that.$emit('input',value);
                    that.$refs.inputRef.setValue(value)
                }	   
            });
            //label
            if(this.label){
                this.labelOver = this.label;
            }
            //提示
            if(this.placeholder){
                this.placeholderOver =  this.placeholderOver + this.placeholder;
            }else if(this.label){
                this.placeholderOver =  this.placeholderOver + this.label;
            }
            //如果已经选中了 长期
            if(this.value == '9999-12-31' || this.value == '99991231' || this.value == ' '){ 
                this.setDateLang(true);
            }
        },
        watch:{
            inputVal(){
                this.$emit('input',this.inputVal);
            },
            value(){
               //如果已经选中了 长期有效
                if(this.value == '9999-12-31' || this.value == '99991231' || this.value == ' '){ 
                    this.setDateLang(true);
                }else if(this.value == ''){
                    this.setDateLang(false);
                }else{
                    this.inputVal = this.value;
                    this.$emit('input',this.value);
                    this.$refs.inputRef.setValue(this.value);
                    this.isLangDate = false;
                }
            }
        },
        data(){
            return{
                inputVal:'',
                isLangDate:false,
                labelOver:'',
                placeholderOver:'',
            }
        },
        methods:{
            setDateLang(isLang){  
                //如果是长期有效
                if(isLang){
                    this.$refs.inputRef.setValue(' ')
                    this.$emit('setDateLang',this.dtName);
                }else{
                    this.$refs.inputRef.setValue('')
                }
                this.isLangDate = isLang;
            }
        }
    }
</script>
<style lang="less" scoped>
    .wk-input-date{
        margin:.9rem 0;
        >div{
            input[readonly='readonly']{
                background: #fff;
            }
            input + img{
                right: 2rem !important  ;
            }
            >div{
                top:0;
                right:-5.5rem;
                width: 5.1rem;
                line-height: 2.1rem;
                padding:0 .5rem;
                border:.05rem solid #d1d1d1;
                color:#666;
                cursor: pointer;
                text-align: center;
                font-size:0.8rem;
                span{
                    padding:.55rem 0 .6rem;
                }
                img{
                    width:1rem;
                    height:1rem;
                    top:.5rem;
                    right:6rem;
                } 
            }
            >div.lang-date{
                color:#D30B01;
                border:.05rem solid #D30B01;
            }
        }
        
    }
</style>
<style lang="less">
    .wk-input-date{
        .input-container{
            input{
                background:url(../../assets/img/register-icon-10.png) no-repeat 95% center;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/BaseCpts/wkInputDate.vue